import defaultErrorHandler from "api/global/default-error-handler";
import {
    requestGetSummary,
    requestGetReportRanges,
    requestGetExceptions,
    requestGetIncomplete,
    requestGetSummaryJobs,
    requestGetExcel,
    requestGetCSV,
    requestFlaggedSummary,
    requestReleaseSingle,
    requestReleaseAll,
    requestDisplayChartToClient,
    requestUpdateReviewed,
    requestUpdateReviewed2,
    requestUpdateReleaseNotes
} from "api/menu/summary/requests";

export const FETCH_SUMMARY_SUCCESS = "FETCH_SUMMARY_SUCCESS";
export const FETCH_FLAGGED_SUMMARY_SUCCESS = "FETCH_FLAGGED_SUMMARY_SUCCESS";
export const FETCH_EXCEPTIONS_SUCCESS = "FETCH_EXCEPTIONS_SUCCESS";
export const FETCH_INCOMPLETE_SUCCESS = "FETCH_INCOMPLETE_SUCCESS";
export const FETCH_REPORT_RANGES_SUCCESS = "FETCH_REPORT_RANGES_SUCCESS";
export const FETCH_SUMMARY_JOBS_SUCCESS = "FETCH_SUMMARY_JOBS_SUCCESS";
export const CLEAR_SUMMARY_SUCCESS = "CLEAR_SUMMARY_SUCCESS";
export const FETCH_SUMMARY_ERROR = "FETCH_SUMMARY_ERROR";
export const LOADING_SUMMARY = "LOADING_SUMMARY";

export const setLoading = (status) => ({
    type: LOADING_SUMMARY,
    payload: status
});

export const fetchSummary = (jobId, reportId) => dispatch => {
    dispatch(setLoading(true));
    requestGetSummary(jobId, reportId)
        .then(response => {
            dispatch({
                type: FETCH_SUMMARY_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const fetchReportRanges = (jobId) => dispatch => {
    dispatch(setLoading(true));
    requestGetReportRanges(jobId)
        .then(response => {
            dispatch({
                type: FETCH_REPORT_RANGES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const fetchIncomplete = (jobId, reportId) => dispatch => {
    dispatch(setLoading(true));
    requestGetIncomplete(jobId, reportId)
        .then(response => {
            dispatch({
                type: FETCH_INCOMPLETE_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const fetchExceptions = (jobId, reportId) => dispatch => {
    dispatch(setLoading(true));
    requestGetExceptions(jobId, reportId)
        .then(response => {
            dispatch({
                type: FETCH_EXCEPTIONS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};


export const fetchSummaryJobs = () => dispatch => {
    dispatch(setLoading(true));
    requestGetSummaryJobs()
        .then(response => {
            dispatch({
                type: FETCH_SUMMARY_JOBS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const clearSummary = () => dispatch => {
    dispatch({
        type: CLEAR_SUMMARY_SUCCESS,
    });
};

export const fetchExportExcel = (jobId, reportId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestGetExcel(jobId, reportId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const fetchExportCSV = (jobId, reportId, callback) => dispatch => {
    dispatch(setLoading(true));
    requestGetCSV(jobId, reportId)
        .then(response => {
            callback(response.data);
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(setLoading(false));
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const fetchFlaggedSummary = (jobId, reportId) => dispatch => {
    dispatch(setLoading(true));
    requestFlaggedSummary(jobId, reportId)
        .then(response => {
            dispatch({
                type: FETCH_FLAGGED_SUMMARY_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const updateReleaseAll = (filteredIdArr, callback) => dispatch => {
    dispatch(setLoading(true));
    requestReleaseAll(filteredIdArr)
        .then(() => {
            callback();
            dispatch(setLoading(false));
            // callback(response.data);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const updateReleaseSingle = (serviceId, released, callback) => dispatch => {
    dispatch(setLoading(true));
    requestReleaseSingle(serviceId, released)
        .then(() => {
            callback();
            dispatch(setLoading(false));
            // callback(response.data);
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const updateDisplayChartToClient = (reportId, status, callback) => dispatch => {
    dispatch(setLoading(true));
    requestDisplayChartToClient(reportId, status)
        .then(() => {
            dispatch(setLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const updateReviewed = (serviceId, status, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateReviewed(serviceId, status)
        .then(() => {
            dispatch(setLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const updateReviewed2 = (serviceId, status, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateReviewed2(serviceId, status)
        .then(() => {
            dispatch(setLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};

export const updateReleaseNotes = (serviceId, releaseNotes, callback) => dispatch => {
    dispatch(setLoading(true));
    requestUpdateReleaseNotes(serviceId, releaseNotes)
        .then(() => {
            dispatch(setLoading(false));
            callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, FETCH_SUMMARY_ERROR));
        });
};
